export default class Utils {


    /**
     * Transforms a Typescript enum into an array of tuples (i.e. objects) with name and value
     * fields.
     * @param enumType the enum to be converted
     * @return result a list of tuples
     */
    public static enumToObject(enumType: any): any[] {

        let result: any[] = [];
        try {
            result = Object.keys(enumType).map((name) => {
                return {
                    name,
                    value: enumType[name as keyof typeof enumType],
                };
            });
        } catch {
            console.log("Input must be an enum");
        }
        return result;

    }

    public static isMobile(): boolean {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    };


    public static configDateSerializer() {

        Date.prototype.toJSON = function() {
            return this.getFullYear() + "-" +
                ((this.getMonth() + 1) < 10 ? "0" + (this.getMonth() + 1) : (this.getMonth() + 1)) + "-" +
                (this.getDate() < 10 ? "0" + this.getDate() : this.getDate()) + "T" +
                (this.getHours() < 10 ? "0" + this.getHours() : this.getHours()) + ":" +
                (this.getMinutes() < 10 ? "0" + this.getMinutes() : this.getMinutes()) + ":" +
                (this.getSeconds() < 10 ? "0" + this.getSeconds() : this.getSeconds()) + "Z";
        };

    }

    public static compareStrings(string1: string, string2: string): number {

        const nameA = string1.toUpperCase(); // Convert name to uppercase for case-insensitive sorting
        const nameB = string2.toUpperCase();
        if (nameA < nameB) { return -1; }
        if (nameA > nameB) { return 1; }
        return 0;

    }

}